module.exports = __webpack_public_path__ + "static/media/pink.15615702.png";